import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { getLogo } from '@ils/examType/logos.js';
import type { ExamType } from '@ils/static/enums.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('ils-loader')
export class ILSLoader extends ChemistryLitElement {
  @property({ type: String, attribute: 'exam-type' }) private readonly examType: ExamType | 'platform' | 'anonymous' =
    'platform';
  @property({ type: String, attribute: 'logo-type' }) private readonly logoType: 'big' | 'small' = 'big';

  override styles() {
    return [
      {
        '@keyframes loader-pulse': {
          '0%': {
            transform: 'scale(0.9)',
          },
          '10%': {
            transform: 'scale(0.95)',
          },
          '20%': {
            transform: 'scale(0.9)',
          },
          '30%': {
            transform: 'scale(1)',
          },
          '75%': {
            transform: 'scale(0.9)',
          },
          '100%': {
            transform: 'scale(0.9)',
          },
        },
        img: {
          width: 'min(200px, 50vw)',
          display: 'block',
          animation: 'loader-pulse 1.5s infinite',
        },
        '[anon-loader]': {
          width: '100px',
          height: '100px',
          borderRadius: '50%',
          background: 'transparent',
          border: `5px solid ${this.colors.accent}`,
          animation: 'loader-pulse 1.5s infinite',
        },
      },
    ];
  }
  override render() {
    if (this.examType === 'anonymous') return html` <div anon-loader></div> `;
    return html` <img src=${getLogo(this.logoType, this.examType || 'platform')} /> `;
  }
}
